import {useEffect, useState} from 'react';

export const useIsEllipsis = (targetElementId: string) => {
  const [isEllipsis, setIsEllipsis] = useState(false);
  useEffect(() => {
    const observedElement = document.getElementById(targetElementId);

    if (!observedElement) {
      return;
    }

    const measureContent = () => {
      setIsEllipsis(
        observedElement.scrollHeight > observedElement.clientHeight,
      );
    };

    if (!window.ResizeObserver) {
      measureContent();
      return;
    }

    const observer = new ResizeObserver(measureContent);

    observer.observe(observedElement);
    return () => {
      observer.disconnect();
    };
  }, [targetElementId]);

  return isEllipsis;
};
